import { observer } from "mobx-react-lite";
import type { ReactNode } from "react";
import { useAppStores } from "../app-context";
import euCoFundedDe from "./assets/eu-co-funded-de.png";
import euCoFundedEn from "./assets/eu-co-funded-en.png";

/** The co-funded lockup belongs to SYNERGISE only. */
export const FundingAcknowledgement = observer(function FundingAcknowledgement(): ReactNode {
  const { locale } = useAppStores();
  return (
    <img
      alt={locale.text("brandingEuCoFunded")}
      className="c3i-funding__emblem"
      height="919"
      src={locale.code === "de" ? euCoFundedDe : euCoFundedEn}
      width={locale.code === "de" ? 4185 : 4119}
    />
  );
});
